import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import { MdOutlineMailOutline } from "react-icons/md";
import { Form, Input, Button, Modal, notification } from "antd";
import { Email } from "@mui/icons-material";
import axios from "axios";
import { useUser } from "../../context/UserContext";
import { ClipLoader } from "react-spinners";
import { FaSpinner } from "react-icons/fa";

export const SignUp = ({ isAuthenticated, setIsAuthenticated }) => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({});

  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const { setUser } = useUser();

  const Loader = <TailSpin visible={true} height="30" width="50" radius="1" />;

  const activateLoader = () => {
    setIsLoading(true);
  };

  const deactivateLoader = () => {
    setIsLoading(false);
  };
  useEffect(() => { console.log('loading', isLoading) }, [isLoading])
  const [api, contextHolder] = notification.useNotification();

  const signUpNotification = (type, text) => {
    api[type]({
      message: text,
    });
  };

  const addCredentialsBasicAuth = async (credentialDetails) => {
    const signUpApiUrl = process.env.REACT_APP_SIGNUP_API;

    try {
      const response = await axios.post(signUpApiUrl, credentialDetails, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response) {
        const responseData = await response.data;
        return responseData;

      }
      else {
        console.error("Error from API:", response.statusText);
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleFormSubmit = async (userDetails) => {
    activateLoader();
    setFormData({
      name: userDetails.fullname,
      email: userDetails.email,
      password: userDetails.password,
      type: "basicauth",
      verificationCode: "",
    });

    const signUpResponse = await addCredentialsBasicAuth({
      name: userDetails.fullname,
      email: userDetails.email,
      password: userDetails.password,
      type: "basicauth",
      verificationCode: "",
    });


    if (signUpResponse.status === 200) {
      deactivateLoader();
      // verificationCode sent successfully
      signUpNotification("success", signUpResponse.message);
      setOtp("");

      setTimeout(() => {
        setOtpSent(true);
        setShowOtpModal(true);
      }, 1000);
    }
    else if (signUpResponse.status === 409) {
      //notifiction user already exist
      deactivateLoader();
      signUpNotification("warning", signUpResponse.message);
      setTimeout(() => {
        navigate("/");
      }, 1000);
    }
  };

  const verifyOtp = async (apiData) => {
    const apiUrl = process.env.REACT_APP_SIGNUP_API;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(apiData),
      });

      return await response.json();
    } catch (error) {
      console.error("Error verifying OTP:", error);
    }
  };

  const handleOtpSubmit = async () => {
    activateLoader();
    const apiData = {
      name: formData.name,
      email: formData.email,
      password: formData.password,
      type: formData.type,
      verificationCode: otp.toString(),
    };

    const otpResponse = await verifyOtp(apiData);

    if (otpResponse.status === 201) {
      setOtpSent(false);
      setShowOtpModal(false);
      localStorage.setItem("clientId", otpResponse.data.clientId);
      localStorage.setItem("accessToken", otpResponse.data.accessToken);
      localStorage.setItem("refreshToken", otpResponse.data.refreshToken);

      localStorage.setItem(
        "BasicAuth",
        JSON.stringify({
          isAuthenticated: true,
          name: formData.name,
          email: formData.email,
          signInType: "BasicAuth",
        })
      );

      signUpNotification("success", otpResponse.message);
      setIsAuthenticated(true);
      setUser({
        name: formData.name,
        email: formData.email,
        signInType: "basicauth",
      });
      setTimeout(() => {
        navigate("/dashboard");
        deactivateLoader();
      }, 1800);
    } else {
      console.log("ELSE asdasd");
      signUpNotification("error", otpResponse?.message);
      deactivateLoader();
    }
    deactivateLoader();
  };

  return (
    <>
      {contextHolder}
      <div className="h-screen grid grid-cols-1 md:grid-cols-1">

        <div className="signin_section flex flex-col justify-center items-center p-6 bg-blue-50">
          <div className="w-full max-w-sm bg-white rounded-lg shadow-lg px-8 py-10">
            <Form
              layout="vertical"
              onFinish={handleFormSubmit}
              requiredMark="optional"
            >
              <Form.Item
                label="Full name *"
                name="fullname"
                rules={[
                  { required: true, message: "Please enter your full name!" },
                ]}
              >
                <Input className="h-10" placeholder="Enter your full name" />
              </Form.Item>

              <Form.Item
                label="Work email *"
                name="email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Please enter a valid email address!",
                  },
                ]}
              >
                <Input className="h-10" placeholder="Enter your work email" />
              </Form.Item>

              <Form.Item
                label="Password *"
                name="password"
                rules={[
                  { required: true, message: "Please enter your password" },
                ]}
              >
                <Input className="h-10" placeholder="Enter your password" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="form-btn w-full flex items-center gap-2 justify-center bg-[#11285b] text-white font-medium py-3 h-[45px] rounded-md hover:bg-[#172e6c]"
                >
                  <MdOutlineMailOutline className="text-[18px]" /> Sign up with
                  Email
                </Button>
              </Form.Item>
            </Form>

            <p className="mt-4 text-sm text-center text-gray-600">
              Already have an account?{" "}
              <a href="/" className="text-blue-600 hover:underline">
                Sign In
              </a>
            </p>
          </div>
        </div>

        <Modal
          title="Enter OTP"
          open={showOtpModal}
          onCancel={() => setShowOtpModal(false)}
          onOk={handleOtpSubmit}
          okText="Verify OTP"
        >
          <Input
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter 4-digit OTP"
            maxLength={4}
          />
        </Modal>

        {isLoading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0, 0, 0, 0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
              backdropFilter: "blur(4px)",
            }}
          >
            <div
              style={{
                background: "#ffffff",
                padding: "32px 40px",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "16px",
                minWidth: "240px",
              }}
            >
              <FaSpinner className="animate-spin" style={{ fontSize: "32px", color: "#1a73e8" }} />
              <span style={{ color: "#1a1a1a", fontSize: "16px", fontWeight: 500 }}>Signing up...</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
